/**
 * Approvals Group client — current group, candidates, members, enable/disable.
 * organization_key is computed on the server from the caller email; never send it.
 */

import { api } from './api';

export interface ApprovalGroupMember {
  userId: number;
  email: string;
  name: string;
}

export interface ApprovalGroupCurrent {
  enabled: boolean;
  members: ApprovalGroupMember[];
  awaitingApprovalCount?: number;
}

export interface ApprovalGroupCandidates {
  candidates: ApprovalGroupMember[];
}

export const approvalGroupsService = {
  getCurrent(): Promise<ApprovalGroupCurrent> {
    return api.get<ApprovalGroupCurrent>('/approval-groups/current');
  },

  getCandidates(search?: string): Promise<ApprovalGroupCandidates> {
    const q =
      search != null && search.trim() !== ''
        ? `?q=${encodeURIComponent(search.trim())}`
        : '';
    return api.get<ApprovalGroupCandidates>(
      `/approval-groups/current/candidates${q}`,
    );
  },

  addMember(userId: number): Promise<ApprovalGroupMember> {
    return api.post<ApprovalGroupMember>('/approval-groups/current/members', {
      userId,
    });
  },

  removeMember(userId: number): Promise<void> {
    return api.delete<void>(`/approval-groups/current/members/${userId}`);
  },

  setEnabled(enabled: boolean): Promise<ApprovalGroupCurrent> {
    return api.patch<ApprovalGroupCurrent>('/approval-groups/current', {
      enabled,
    });
  },
};
